/**
 * Created by ah on 18/01/17.
 */
import moment from 'moment';
import {toImmutable} from '../../utils'
import {Keys} from '../constants'

// Default transformation transforms an array into an immutable map with the element.id as key
// [{id:'1', name:'Kalle'}, {id:'2', name:'Pelle' }] becomes:
// { '1':{id:'1', name:'Kalle'}, '2':{id:'2', name:'Pelle' }}
const defaultTransform = (obj) => {
    if(!Array.isArray(obj)) {
        return toImmutable(obj);
    }
    let result = {};
    obj.forEach(e => {
        result[e[Keys.ID]] = e;
    });
    return toImmutable(result);
};

export function standardLoadingReducerFactory(ACTION_BASE, property, transformFn) {
    const REQUEST = ACTION_BASE+'_REQUEST';
    const SUCCESS = ACTION_BASE+'_SUCCESS';
    const FAILURE = ACTION_BASE+'_FAILURE';
    return {
        [REQUEST](state, action) {

            return state.merge({loading:true, loadingFailed:false});
        },
        [SUCCESS](state, action) {
            const result = !!transformFn?transformFn(action.payload[property], state):defaultTransform(action.payload[property]);

            return state.merge({loading:false, loadingFailed:false, [property]:result, lastLoadSuccess:moment()});
        },
        [FAILURE](state, action) {
            // assert(action.error === true && action.payload instanceof Error);

            // when a property gets rejected then the non promise properties go in the meta object
            // assert(action.meta.adminId);
            return state.merge({loading:false, loadingFailed:true, errorMessage:action.payload.message});
        },
    }
}



// WEBPACK FOOTER //
// ./src/model/reducers/reducer-utils.js